import { ModulesMap, ModulesConfigMap } from "../data/modulesMaps";

export default {
  getReportsFinanceByServices: {
    apiServiceMethodName:
      ModulesConfigMap[ModulesMap.REPORTS_FINANCE_BY_SERVICES].GET_REPORTS_FINANCE_BY_SERVICES
  }
}